import * as React from "react";
import * as ReactDOM from "react-dom/client";
import { App } from "./App";
import { getWidgetById } from "./openai-widget/lib/firestore";
import { 
  createShadowDOMContainer, 
  injectStylesIntoShadowDOM, 
  isShadowDOMSupported, 
  createEmotionCacheForShadowRoot 
} from "./shadow-dom-utils";
import { CacheProvider } from '@emotion/react';

export const init = async (widgetId: string, selector: string) => {
  const element = document.querySelector(selector);
  if (element) {
    try {
      // Check if Shadow DOM is supported
      if (isShadowDOMSupported()) {
        // Create Shadow DOM container
        const { shadowRoot, container } = createShadowDOMContainer(element);
        
        // Inject Roboto font
        const fontLink = document.createElement('link');
        fontLink.rel = 'stylesheet';
        fontLink.href = 'https://fonts.googleapis.com/css?family=Roboto:300,400,500,700&display=swap';
        shadowRoot.appendChild(fontLink);

        // Create emotion cache for shadow root
        const cache = createEmotionCacheForShadowRoot(shadowRoot);

        // Render app with CacheProvider
        const root = ReactDOM.createRoot(container);
        root.render(
          <CacheProvider value={cache}>
            <App widgetId={widgetId} />
          </CacheProvider>
        );
      } else {
        // Fallback to regular DOM if Shadow DOM is not supported
        console.warn('Shadow DOM not supported, using regular DOM');
        const root = ReactDOM.createRoot(element);
        root.render(<App widgetId={widgetId} />);
      }
      
      const widget = await getWidgetById(widgetId);

      if (!widget) {
        return {
          error: `Widget with id "${widgetId}" not found.`,
        };
      }

      return null;
    } catch (error) {
      console.error('Error initializing widget:', error);
      
      // Fallback to regular DOM if Shadow DOM fails
      const root = ReactDOM.createRoot(element);
      root.render(<App widgetId={widgetId} />);
      
      const widget = await getWidgetById(widgetId);
      if (!widget) {
        return {
          error: `Widget with id "${widgetId}" not found.`,
        };
      }
      return null;
    }
  } else {
    return {
      error: `Element with selector "${selector}" not found.`,
    };
  }
};

// Development mode setup with Shadow DOM
// if (process.env.NODE_ENV === 'development') {
//   const rootElement = document.getElementById("root");
//   if (rootElement) {
//     try {
//       // Create Shadow DOM container for development
//       const { shadowRoot, container } = createShadowDOMContainer(rootElement);
      
//       // Inject Roboto font
//       const fontLink = document.createElement('link');
//       fontLink.rel = 'stylesheet';
//       fontLink.href = 'https://fonts.googleapis.com/css?family=Roboto:300,400,500,700&display=swap';
//       shadowRoot.appendChild(fontLink);

//       // Create emotion cache for shadow root
//       const cache = createEmotionCacheForShadowRoot(shadowRoot);

//       // Render app with CacheProvider
//       const root = ReactDOM.createRoot(container);
//       root.render(
//         <CacheProvider value={cache}>
//           <App widgetId="yzfeAnwwQIh7671FgWE5" />
//         </CacheProvider>
//       );
//       console.log("Development mode setup with Shadow DOM");
//     } catch (error) {
//       console.error('Error initializing development widget:', error);
//       // Fallback to regular DOM if Shadow DOM fails in development
//       const root = ReactDOM.createRoot(rootElement);
//       root.render(<App widgetId="yzfeAnwwQIh7671FgWE5" />);
//     }
//   }
// }
